import get from 'lodash/get'
import isEqual from 'lodash/isEqual'
import NotificationSystem from 'rc-notification'
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux';
import classNames from 'classnames';

// Comps
import { FullWideNotification, BasicNotification, ImageNotification, TopbarNotification } from '../components/Notification'

// Redux
import { decreaseTopBarNotification } from '..//redux/actions/notificationsActions'


// Notifications manager instance containers
let notLU = null, notRU = null, notTC = null;

// Actual component
function withNotifications(WrappedComponent) {
  return class extends Component {
    showNotification = (meta) => {
      // ::TODO:: Implment bottom right for dev messages
      // console.warn("xxx meta", meta);
      const template = this.createNotification(meta);
      if (template === null) return false;
      switch(template.className){
        case 'left-up':
          if (!!notLU) notLU.notice({
            ...template,
            closable: true,
            style: { top: 0, left: 0 }
          });
          break;

        case 'right-up':
          if (!!notRU) notRU.notice({
            ...template,
            closable: true,
            style: { top: 0, left: 'calc(100vw - 100%)'}
          });
          break;

        case 'right-bottom':
        case 'notification--bigger_font':
          if (!!notRU) notRU.notice({
            ...template,
            closable: true,
            style: { bottom: 0, left: 'calc(100vw - 100%)'}
          });
          break;

        case 'alert-notification':
          notLU.notice({
            ...template,
            closable: template.content.props.action === 'Más información' ? false : true,
            style: { top: 0, left: 'calc(100vw - 100%)'}
          });
          break;

        default:
          if (!!notTC) notTC.notice({
            ...template,
            closable: true,
            style: { top: 0, left: 0}
          });
          break;

      } // END switch

    } // END showNotification

    createNotification = (meta) => {
        const { type, duration, className } = meta;
        const normalNotClass = classNames({
          'right-up': !className,
          [className]: className
        });

        switch(type){
          case 'normal':
            return ({
              content: <BasicNotification { ...meta } />,
              duration: !isNaN(parseFloat(duration)) ? duration : 5,
              className: normalNotClass
            });

          case 'bar':
            return({
              content:  <FullWideNotification { ...meta } />,
              duration: !isNaN(parseFloat(duration)) ? duration : 0,
              className: 'full'
            })

          case 'caution':
            return({
              content: <TopbarNotification { ...meta } />,
              duration: 0,
              className: 'alert-notification',
              onClose: () => this.props.dispatch(decreaseTopBarNotification())
            })

          case 'image':
            return({
              content:  <ImageNotification { ...meta } />,
              duration: !isNaN(parseFloat(duration)) ? duration : 7,
              className: 'right-up'
            })

          case 'basic':
            return({
              content:  <BasicNotification { ...meta } />,
              duration: !isNaN(parseFloat(duration)) ? duration : 3,
              className: 'right-up'
            })

          default:
            return null

        }

    } // END createNotification


    componentDidUpdate(prevProps){
      const
        not = get(this, 'props.notifications.last'),
        prevNot = get(prevProps, 'notifications.last'),
        token = get(this, 'props.token'),
        prevToken = get(prevProps, 'token')

      if (!isEqual(not, prevNot)) {
        this.showNotification(not);
        return false;

      };

      if(!isEqual(token, prevToken)){
        if(token === null){
          const notifications = document.querySelectorAll('.alert-notification')
          notifications.forEach(notification => {
            notification.remove()
            this.props.dispatch(decreaseTopBarNotification())
          })
        }
      }

    } // END componentDidUpdate


    componentDidMount(){
      NotificationSystem.newInstance({}, n => notLU = n);
      NotificationSystem.newInstance({}, n => notRU = n);
      NotificationSystem.newInstance({}, n => notTC = n);


    } // END componentDidMount


    componentWillUnmount() {
      [get(notLU, 'destroy'), get(notRU, 'destroy'), get(notTC, 'destroy')]
        .forEach(fn => {
          try {
            if (typeof fn === 'function') fn();

          } catch(err) {
            console.error('NotificationsHOC', err);
            return false;

          } // END try

        }); // END forEach


    } // END componentWillUnmount
    //


    render() {
      return <WrappedComponent { ...this.props } />

    } // END render

  };

} // END withNotifications


const mapStateToProps = state => ({
  notifications: state.notifications,
  token: get(state, 'account.access_token')

}) // END mapStateToProps


const composedWithPrompts = compose(
  connect(mapStateToProps, null),
  withNotifications

) // END composedWithPrompts


export default composedWithPrompts;



// WEBPACK FOOTER //
// ./src/helpers/NotificationsHoc.js